import React from 'react';

const sizes = {
  small: 'p-1.5',
  medium: 'p-2',
  large: 'p-2.5',
};

/**
 * Quiet icon-only button for row actions, card headers, and nav toggles.
 * Replaces the repeated p-2 rounded-xl hover:bg-gray-100 hand-rolls.
 */
export function IconButton({
  children,
  size = 'medium',
  label,
  className = '',
  ...props
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={`inline-flex items-center justify-center rounded-xl text-gray-500 hover:text-brand-500 dark:text-gray-400 dark:hover:text-brand-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-150 cursor-pointer shrink-0 min-h-[44px] min-w-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-800 ${sizes[size] || sizes.medium} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default IconButton;
